export enum DevicesModuleAttribute {
  Type = 'type',
  Browser = 'browser',
  Os = 'os',

  IpAddress = 'ip_address',
  FirstSeenAt = 'first_seen_at',
  LastSeenAt = 'last_seen_at',
  NetworkCity = 'network_city',
  NetworkRegion = 'network_region',
  NetworkCountry = 'network_country',
  Latitude = 'latitude',
  Longitude = 'longitude',
  GpsLatitude = 'gps_latitude',
  GpsLongitude = 'gps_longitude',
  ProxyConnection = 'proxy_connection',
  TorConnection = 'tor_connection',
  DatacenterConnection = 'datacenter_connection',
  VpnConnection = 'vpn_connection',
  ThreatRating = 'threat_rating',
  BrowserFingerprint = 'browser_fingerprint',
  DeviceFingerprint = 'device_fingerprint',
  ServiceProvider = 'service_provider',
  DeviceHandoffMethod = 'device_handoff_method',
  IpConnectionType = 'ip_connection_type',
}
